import { FC } from "react";

import { useFormV2Context } from "../../../contexts/FormV2Context";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormCheckbox } from "@/forms-design-system/FormCheckbox";
import { FormCheckboxGroup } from "@/forms-design-system/FormCheckboxGroup";

interface CommunicationPreferencesFieldProps {
  value: string[];
  onChange: (contactListIds: string[]) => void;
}

export const CommunicationPreferencesField: FC<CommunicationPreferencesFieldProps> = ({ value, onChange }) => {
  const { t } = useTranslate();
  const { communicationPreferences, communicationPreferencesTitle, formOrganization } = useFormV2Context();

  if (communicationPreferences.length === 0) {
    return null;
  }

  const isSingleOption = communicationPreferences.length === 1;
  const questionTitle =
    communicationPreferencesTitle ||
    t("common", "communicationPreferences.defaultQuestionTitle", { organizationName: formOrganization.name });

  return (
    <FormCheckboxGroup
      data-test="communication-preferences-field"
      label={isSingleOption ? undefined : questionTitle}
      value={value}
      onChange={(contactListIds: string[]) => onChange(contactListIds)}
    >
      {communicationPreferences.map((option) => (
        <FormCheckbox
          key={option.contactListId}
          id={option.contactListId}
          name={`communicationPreferences.${option.contactListId}`}
          value={option.contactListId}
          label={isSingleOption ? questionTitle : option.name}
        />
      ))}
    </FormCheckboxGroup>
  );
};
